import { Article, Journalist } from './types';

export const mockArticles: Article[] = [
  {
    id: "1",
    title: "The Future of Sustainable Technology in Emerging Markets",
    author: "Emma Rodriguez",
    authorId: "1",
    date: "May 20, 2023",
    image: "/placeholder.svg",
    excerpt: "How sustainable technology solutions are transforming business practices and consumer behavior in developing economies around the world.",
    readTime: "8 min read",
    topics: ["Technology", "Sustainability", "Business"],
    hasAudio: true
  },
  {
    id: "2",
    title: "Understanding the Latest Climate Policy Shifts",
    author: "Michael Chen",
    authorId: "2",
    date: "May 18, 2023",
    image: "/placeholder.svg",
    excerpt: "An analysis of recent climate policy changes across major economies and their potential impact on global sustainability goals.",
    readTime: "12 min read",
    topics: ["Climate", "Politics", "International Affairs"],
    hasAudio: false
  },
  {
    id: "3",
    title: "The Rise of Digital Currencies in Traditional Banking",
    author: "Sarah Johnson",
    authorId: "3",
    date: "May 15, 2023",
    image: "/placeholder.svg",
    excerpt: "How central banks and financial institutions are adapting to the integration of digital currencies into mainstream financial systems.",
    readTime: "10 min read",
    topics: ["Finance", "Technology", "Economy"],
    hasAudio: true
  },
  {
    id: "4",
    title: "AI Ethics: Navigating the Challenges of Machine Learning Bias",
    author: "David Wong",
    authorId: "4",
    date: "May 12, 2023",
    image: "/placeholder.svg",
    excerpt: "Examining the ethical considerations and practical solutions to addressing bias in artificial intelligence systems.",
    readTime: "14 min read",
    topics: ["Technology", "Ethics", "AI"],
    hasAudio: true
  },
  {
    id: "5",
    title: "Urban Planning Innovations for Post-Pandemic Cities",
    author: "Lisa Martinez",
    authorId: "5",
    date: "May 10, 2023",
    image: "/placeholder.svg",
    excerpt: "How urban designers and city planners are reimagining public spaces and infrastructure in response to lessons learned from the pandemic.",
    readTime: "9 min read",
    topics: ["Urban Planning", "Health", "Social Justice"],
    hasAudio: false
  },
  {
    id: "6",
    title: "The Evolution of Remote Work Policies in Fortune 500 Companies",
    author: "James Taylor",
    authorId: "6",
    date: "May 8, 2023",
    image: "/placeholder.svg",
    excerpt: "Analyzing how major corporations are establishing long-term remote and hybrid work models in the post-pandemic business landscape.",
    readTime: "11 min read",
    topics: ["Business", "Economy", "Technology"],
    hasAudio: true
  },
  {
    id: "7",
    title: "Global Supply Chain Resilience: Lessons from Recent Disruptions",
    author: "Emma Rodriguez",
    authorId: "1",
    date: "May 5, 2023",
    image: "/placeholder.svg",
    excerpt: "Strategic approaches to building more resilient supply chains in response to global disruptions, trade tensions, and pandemic impacts.",
    readTime: "13 min read",
    topics: ["Business", "International Affairs", "Economy"],
    hasAudio: false
  },
  {
    id: "8",
    title: "Education Technology Revolution: Beyond Emergency Remote Learning",
    author: "Michael Chen",
    authorId: "2",
    date: "May 3, 2023",
    image: "/placeholder.svg",
    excerpt: "How educational institutions are implementing technology-driven approaches to create more effective and accessible learning environments.",
    readTime: "8 min read",
    topics: ["Education", "Technology", "Social Justice"],
    hasAudio: true
  },
  {
    id: "9",
    title: "The Transformation of Healthcare Systems Through Digital Innovation",
    author: "Sarah Johnson",
    authorId: "3",
    date: "May 1, 2023",
    image: "/placeholder.svg",
    excerpt: "Exploring how telehealth, AI diagnostics, and other digital healthcare solutions are changing patient care and medical practices.",
    readTime: "15 min read",
    topics: ["Health", "Technology", "Science"],
    hasAudio: true
  },
  {
    id: "10",
    title: "Renewable Energy Investments: Analyzing Market Trends and Opportunities",
    author: "David Wong",
    authorId: "4",
    date: "April 29, 2023",
    image: "/placeholder.svg",
    excerpt: "A detailed look at investment patterns in renewable energy sectors and the economic factors driving sustainable energy adoption.",
    readTime: "10 min read",
    topics: ["Finance", "Sustainability", "Energy"],
    hasAudio: false
  }
];

export const mockJournalists: Journalist[] = [
  {
    id: "1",
    name: "Emma Rodriguez",
    avatar: "/placeholder.svg",
    bio: "Technology and sustainability journalist with 10+ years experience covering emerging market trends",
    followers: 12500,
    topics: ["Technology", "Sustainability", "Business"]
  },
  {
    id: "2",
    name: "Michael Chen",
    avatar: "/placeholder.svg",
    bio: "Climate policy analyst and political correspondent for major international publications",
    followers: 8700,
    topics: ["Climate", "Politics", "International Affairs"]
  },
  {
    id: "3",
    name: "Sarah Johnson",
    avatar: "/placeholder.svg",
    bio: "Finance reporter specializing in digital currencies, fintech, and economic policy",
    followers: 15300,
    topics: ["Finance", "Technology", "Economy"]
  },
  {
    id: "4",
    name: "David Wong",
    avatar: "/placeholder.svg",
    bio: "AI ethics researcher and technology journalist covering machine learning developments",
    followers: 9200,
    topics: ["Technology", "Ethics", "AI"]
  },
  {
    id: "5",
    name: "Lisa Martinez",
    avatar: "/placeholder.svg",
    bio: "Urban planning expert and health policy journalist with focus on community development",
    followers: 7600,
    topics: ["Urban Planning", "Health", "Social Justice"]
  },
  {
    id: "6",
    name: "James Taylor",
    avatar: "/placeholder.svg",
    bio: "Business correspondent covering workplace trends, corporate governance, and economic policy",
    followers: 11800,
    topics: ["Business", "Economy", "Technology"]
  }
];

export const mockFollowedJournalists: Journalist[] = mockJournalists.map((journalist, index) => ({
  ...journalist,
  unread: index % 2 === 0 ? Math.floor(Math.random() * 5) + 1 : 0,
}));

export const mockTopics = [
  "Technology",
  "Climate",
  "Politics",
  "Business",
  "Health",
  "Finance",
  "Economy",
  "Ethics",
  "AI",
  "Urban Planning",
  "Social Justice",
  "Education",
  "Science",
  "Sustainability",
  "Energy",
  "International Affairs"
];

export const getGreeting = (): string => {
  const hour = new Date().getHours();
  if (hour < 12) return "Good morning";
  if (hour < 18) return "Good afternoon";
  return "Good evening";
};
